var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mu-dialog',{staticClass:"mp-dialog",attrs:{"title":"公众号授权","width":"500","open":_vm.open},on:{"close":_vm.close}},[_c('div',{staticClass:"qrcode-wrapper"},[_c('img',{attrs:{"src":("https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=" + (_vm.user.qrimgTicket))}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bae620e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/mp.vue
// module id = null
// module chunks = 